import { Link } from 'react-router-dom'

/**
 * Public support page rendered inside the React application shell.
 *
 * @returns JSX.Element The support page
 */
function SupportPage() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <p className="legal-kicker">Vault Financial</p>
        <h1>Support</h1>
        <p className="legal-subtitle">
          Help for Plaid linking, reconnect prompts, permissions, and financial account support questions.
        </p>
      </div>

      <div className="legal-grid">
        <section className="legal-card">
          <h2>Email support</h2>
          <p>
            Reach the launch team at{' '}
            <a href="mailto:support@vaultfinance.ai">support@vaultfinance.ai</a>.
          </p>
        </section>

        <section className="legal-card">
          <h2>Before you contact us</h2>
          <p>
            If a linked institution is marked as needing reconnection, return to the Accounts page and
            use the reconnect action on the affected institution card. Account deletion is available in
            the app under Account Settings, and support is the fallback if the cancellation email fails.
          </p>
        </section>

        <section className="legal-card">
          <h2>Policies</h2>
          <p>
            Review our <Link to="/privacy">Privacy Policy</Link> and{' '}
            <Link to="/terms">Terms of Service</Link> for details on linked data handling.
          </p>
        </section>
      </div>

      <div className="legal-actions">
        <Link to="/" className="btn btn-primary">
          Return Home
        </Link>
        <Link to="/accounts" className="btn btn-secondary">
          Manage Linked Institutions
        </Link>
      </div>
    </div>
  )
}

export default SupportPage
